export const ProgressEnum = {
  '100-80': {
    value: '100-80',
    className: 'bg-primary',
    circularColor: 'c-primary',
    textColor: 'c-primary',
  },
  '80-60': {
    value: '80-60',
    className: 'bg-success',
    circularColor: 'c-success',
    textColor: 'c-success',
  },
  '60-30': {
    value: '60-30',
    className: 'bg-warning',
    circularColor: 'c-warning',
    textColor: 'c-warning',
  },
  '30-0': {
    value: '30-0',
    className: 'bg-danger',
    circularColor: 'c-danger',
    textColor: 'c-danger',
  },
};
